import React from 'react';
import { Checkbox } from 'antd';
import DateTabLabel from './date-tab-label';
import './date-tabs.scss';

interface DateTabsProps {
	dates: { date: string; day: string }[];
	dateFormat: string;
	onChange: (value: string) => void;
	value?: string;
	className?: string;
}

const DateTabs = ({ dates, dateFormat, onChange, value, className }: DateTabsProps) => {
	const getTabsOptions = () =>
		dates.map(date => ({
			label: <DateTabLabel date={date} dateFormat={dateFormat} />,
			value: date.date,
			onChange: e => onChange(e.target.value)
		}));

	return (
		<div className={`bringg-date-tabs ${className}`}>
			<Checkbox.Group className="date-tabs" options={getTabsOptions()} value={[value]} />
		</div>
	);
};

export default DateTabs;
